import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { useMemo } from "react"
import { Query } from "@oysterhr/schema"

const COUNTRY_LIST_QUERY = gql`
  query BenefitsSharedCountriesWithBenefitsData {
    availableCountryBenefits {
      collection {
        countryCode
      }
    }
  }
`

export const useBrainCountryList = () => {
  const { data, ...rest } = useQuery<Pick<Query, "availableCountryBenefits">>(COUNTRY_LIST_QUERY)

  const list = useMemo(
    () => data?.availableCountryBenefits.collection.map(({ countryCode }) => countryCode) ?? [],
    [data],
  )

  return { ...rest, data: list }
}
